module.exports = __webpack_public_path__ + "static/media/303ColumnLabel--11.11e97182.svg";